// LivestreamMiniModal.js
import { connect } from 'react-redux';

import LivestreamMiniModal from '../component/LivestreamMiniModal.jsx';
import toggleModal from '../action/toggleModal.js';

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: payload => dispatch(toggleModal(payload)),
  };
};

export default connect(null, mapDispatchToProps)(LivestreamMiniModal);
